module.exports = __webpack_public_path__ + "static/img/4.7f2089a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/4/zh/4.png
// module id = dyuo
// module chunks = 0